import { render, staticRenderFns } from "./CompositeBillingDashboard.vue?vue&type=template&id=71f6ca9d&scoped=true&"
import script from "./CompositeBillingDashboard.vue?vue&type=script&lang=js&"
export * from "./CompositeBillingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CompositeBillingDashboard.vue?vue&type=style&index=0&id=71f6ca9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6ca9d",
  null
  
)

export default component.exports